import { ReactComponent as IconChevronDown } from '@/assets/svgs/profile-chevron.svg'
import rem from '@/utils/rem'
import classname from 'classnames'
import React, { useCallback, useRef, useState, useEffect } from "react"
import { Manager, Popper, Reference } from "react-popper"
import MultiClamp from 'react-multi-clamp'
import clickCheck from '@/utils/click-check'

export const Toggle = (setOpened, isOpened) => {
    setOpened(!isOpened)
}

export function PopoverFunction(setListRef, maxWidth, isOpened, options, value, Select) {
    return <Popper placement="bottom"
        data-testid="selectTest"
        modifiers={[
            {
                name: 'preventOverflow',
                enabled: true
            },
            {
                name: 'offset',
                options: { offset: [0, 6] }
            }
        ]}
    >
        {({ ref, style, placement }) => (
            <div ref={node => setListRef(node, ref)} data-placement={placement} className={`dropdown3__list ${(isOpened && "dropdown__list--open") || ""}`}>
                {options?.map((item, index) => {
                    return ReturnDropdownValueList(value, item, Select, index)
                })}
            </div>
        )}
    </Popper>
}

export function ReturnDropdownValueList(value, item, Select, index) {
    return <div data-testid="selectTest1" className={value?.id === item.id ? 'dropdown__item dropdown__item__selected' : 'dropdown__item'} onClick={() => Select(item)} key={index}>
        <span className={'dropdown3__item-span__margin'} title={item.name}>{item.name}</span>
    </div>
}

export function SetDataForButtonRef(buttonReference, listReference) {
    const setButtonRef = useCallback((node, ref) => {
        buttonReference.current = node
        return ref(node)
    }, [])

    const setListRef = useCallback((node, ref) => {
        listReference.current = node; return ref(node);
    }, [])
    return { setButtonRef, setListRef }
}

export function SelectFunc(setOpened, submit) {
    return (item) => {
        setOpened(false); return submit(item);
    }
}

const Dropdown = ({ text, value, options, submit, maxWidth, ghost, full, disabled }) => {
    const [isOpened, setOpened] = useState(false)
    const listReference = useRef(null)
    const buttonReference = useRef(null)

    const dropdownStyle = {
        width: rem(maxWidth)
    }

    const dropdownClass = classname({
        'dropdown__button': true,
        'dropdown__button--modified': true,
        'dropdown__button--disabled': disabled,
        'dropdown__button--ghost': ghost,
        'dropdown__button--full': full
    })

    useEffect(() => {
        const clickCheckCb = (e) => clickCheck(isOpened, listReference, buttonReference, setOpened, e);
        document.addEventListener('mousedown', clickCheckCb)
        return () => {
            return document.removeEventListener('mousedown', clickCheckCb)
        }
    }, [isOpened])

    const { setButtonRef, setListRef } = SetDataForButtonRef(buttonReference, listReference)

    const Select = SelectFunc(setOpened, submit)

    return (
        <Manager>
            <Reference>
                {({ ref }) => (
                    <div tabIndex="0"
                        data-testid="toggleTest"
                        className={dropdownClass}
                        id="openToggle"
                        style={dropdownStyle}
                        ref={node => setButtonRef(node, ref)}
                        onClick={() => Toggle(setOpened, isOpened)}
                    >
                        <div className={"dropdown3__label__selected"}><MultiClamp clamp={1}>{value ? value.name : text}</MultiClamp></div>
                        {!disabled && (
							<div><IconChevronDown /></div>
						)}

                    </div>
                )}
            </Reference>
            {isOpened && (
                PopoverFunction(setListRef, maxWidth, isOpened, options, value, Select)
            )}
        </Manager>
    )
}

export default Dropdown
